import React from "react";
import l from "components/util/l";
import PrototypeAnnotation from "components/brief/util/helpers/PrototypeAnnotation";
import PrototypeFrame from "components/brief/util/helpers/PrototypeFrame";
import PrototypeScreenshot from "components/brief/util/helpers/PrototypeScreenshot";

// The client side of the prototype. Its namesake under proposals/ is the developer side of
// the same object.
const PrototypeView = ({
  annotations,
  documentUrl,
  frameRef,
  proposals,
  selectedProposalIndex,
  editingAnnotationId,
  draftText,
  isCapturingScreenshot,
  isDeveloper,
  isLoadError,
  isSaving,
  isUploadingScreenshot,
  hasPrototype,
  onClickSaveChanges,
  onChangeSelectedProposalIndex,
  onClickStartEditingComment,
  onClickSaveEditingComment,
  onClickCancelEditingComment,
  onClickRemoveComment,
  onClickAddScreenshotComment,
  onChangeDraftText,
  onChangeResolvedState,
  onClickSendComments,
  onFinishScreenshot,
}) => {
  return (
    <div className="h-100 w-100 flex-fill d-flex flex-column overflow-hidden text-dark" style={{ minWidth: 0 }}>
      {/* Header: which proposal is being reviewed, and the sending actions */}
      <div className="px-3 py-2 d-flex align-items-center justify-content-between flex-shrink-0"
        style={{ backgroundColor: "#00000020" }}>

        <h4 className="font-weight-bold text-white mb-0">{l("Prototipo%PA560")}</h4>

        <div>

        <button
          type="button"
          className="btn btn-sm btn-lighter-white border mr-2"
          onClick={onClickSaveChanges}
        >
          <i className="fas fa-save mr-2"></i>
          {l("Guardar cambios%PA615")}
        </button>

        <button
          type="button"
          className="btn btn-sm btn-primary mr-3"
          onClick={onClickSendComments}
        >
          {isSaving
            ? <i className="fas fa-spinner fa-pulse mr-2"></i>
            : <i className="fas fa-paper-plane mr-2"></i>}
          {l("Enviar comentarios%PA610")}
        </button>

        {proposals.length > 1 && (
          <select
            className="form-control form-control-sm"
            style={{ width: 220 }}
            value={selectedProposalIndex}
            onChange={(event) => onChangeSelectedProposalIndex(Number(event.target.value))}
          >
            {proposals.map((proposal, index) => (
              <option key={`prototype-proposal-${index}`} value={index}>
                {proposal.name}
              </option>
            ))}
          </select>
          
        )}
        </div>
      </div>

      {/* Body: the prototype frame beside the comments panel */}
      <div className="flex-fill d-flex overflow-hidden" style={{ minHeight: 0 }}>
        <div className="flex-fill overflow-hidden position-relative" style={{ minHeight: 0 }}>
          <PrototypeFrame
            className="w-100 h-100"
            documentUrl={documentUrl}
            frameRef={frameRef}
            hasPrototype={hasPrototype}
            isLoadError={isLoadError}
          />
        </div>


        <aside
          className="h-100 d-flex flex-column flex-shrink-0"
          style={{ width: 360, minWidth: 360, background: "#ffffff", borderLeft: "1px solid #e5e7eb" }}
        >
          <div className="px-3 py-3 bg-white border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center overflow-hidden">
        
                <div
                  className="rounded-circle p-2 mr-2 d-flex align-items-center justify-content-center"
                  style={{ background: "#f3f4f6" }}
                >
                  <i className="fas fa-comments text-primary"></i>
                </div>

                <div className="overflow-hidden">
                  <div className="font-weight-bold text-dark">{l("Comentarios%PA365")}</div>
                  <small className="text-muted">
                    {l("Selecciona un área del prototipo para comentar%BR053")}
                  </small>
                </div>
              </div>

              <div className="d-flex align-items-center flex-shrink-0">
                <button
                  type="button"
                  className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                  style={{ width: 30, height: 30, borderRadius: 999, padding: 0 }}
                  title={l("Comentar sobre el prototipo%BR012")}
                  disabled={!hasPrototype || isUploadingScreenshot}
                  onClick={onClickAddScreenshotComment}
                >
                  <i className={`fas ${isUploadingScreenshot ? "fa-spinner fa-pulse" : "fa-plus"}`}></i>
                </button>
              </div>
            </div>
          </div>

          <div className="flex-fill overflow-auto px-2 py-3 bg-light">
            {annotations.length === 0 && (
              <div className="text-center text-muted py-5 px-3">
                <div
                  className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{ width: 54, height: 54, background: "#ffffff", border: "1px solid #e5e7eb" }}
                >
                  <i className="fas fa-comment-dots fa-lg"></i>
                </div>
                <div style={{ fontSize: "0.9rem", lineHeight: 1.45 }}>
                  {l("No hay comentarios todavía.%PA789")}
                </div>
              </div>
            )}

            {annotations.map((annotation) => (
              <PrototypeAnnotation
                key={annotation.id}
                annotation={annotation}
                draftText={draftText}
                isDeveloper={isDeveloper}
                isEditing={editingAnnotationId === annotation.id}
                onChangeDraftText={onChangeDraftText}
                onChangeResolvedState={onChangeResolvedState}
                onClickCancelEditing={onClickCancelEditingComment}
                onClickRemove={onClickRemoveComment}
                onClickSaveEditing={onClickSaveEditingComment}
                onClickStartEditing={onClickStartEditingComment}
              />
            ))}
          </div>

        </aside>

      </div>

      {/* While a screenshot is taken the prototype must stay untouched, so the screen is blocked */}
      {isCapturingScreenshot && (
        <PrototypeScreenshot
          frameRef={frameRef}
          onCancel={() => onFinishScreenshot(null)}
          onCapture={onFinishScreenshot}
        />
      )}
    </div>
  );
};

export default PrototypeView;
